var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5FEB@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u94B1\\u5305",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u94B1\\u5305\\u5907\\u4EFD-9",
    transform: "translate(-977.000000, -326.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8F6C\\u8D26\\u5F39\\u7A97\\u5907\\u4EFD-2",
    transform: "translate(880.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(0.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-7\\u5907\\u4EFD",
    transform: "translate(51.000000, 235.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input",
    transform: "translate(31.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5FEB",
    transform: "translate(15.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#BFCBCB",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2576827,16.924861 L13.4382714,13.8865447 L19,16.7838776 L19,15.0223742 L13.538792,9.63606771 L13.538792,6.24748087 C13.538792,5.35243619 12.8498269,4 12.0000382,4 C11.1501884,4 10.4612844,5.35243619 10.4612844,6.24748087 L10.4612844,9.63606771 L5,15.0223742 L5,16.7838776 L10.4692424,13.8865447 L10.6929811,17.1741717 C10.6929811,17.2535593 10.7018555,17.3295848 10.7097523,17.4058837 L9.71644579,18.3539339 L9.71644579,19.4 L12.0133574,18.600703 L12.0497104,18.5879946 L14.2489731,19.4 L14.2489731,18.3539339 L13.223346,17.3759626 L13.2576827,16.924861 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.0c58bf6b9aaf6bbbca690020190d5433.svg";
export { ForwardRef as ReactComponent };